import React from 'react';
import PropTypes from 'prop-types';

import Refresh from '@decisiv/iconix/lib/components/Refresh';

import Button from '@decisiv/ui-components/lib/components/Button';
import Message from '@decisiv/ui-components/lib/components/Message';

import { ERROR_PANEL } from './copy';
import { TerminalPanel } from './styles';

/**
 * Shown when the create failed (Figma 787:76652).
 *
 * Deliberately generic. A field-level problem is caught on the step it belongs to,
 * so anything reaching here is unexpected, and the details are in the server log
 * rather than on screen. RETRY resubmits the same draft; the wizard's BACK returns
 * to the last step so the admin can change something first.
 */
function ErrorPanel({ onRetry }) {
  return (
    <TerminalPanel>
      <Message
        intent="danger"
        size="large"
        title={ERROR_PANEL.title}
        variant="vertical"
      >
        {ERROR_PANEL.body}
      </Message>
      <Button icon={Refresh} text={ERROR_PANEL.retry} onClick={onRetry} />
    </TerminalPanel>
  );
}

ErrorPanel.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default ErrorPanel;
